// extracted by mini-css-extract-plugin
module.exports = {"title":"e__s","hidden":"e_0s","showMore":"e_1s","features":"e_2s","featuresOpened":"e_3s","colorPositive":"e_4s","colorNegative":"e_5s","buttonOpen":"e_6s","hiddenDesktop":"e_7s"};